import {
	useStarterDashboardV2PageData,
	useStarterDashboardV2PageFcm,
} from 'src/app/pages/starterDashboardV2/pageContext';
import type { OnlineShareChannel } from 'src/app/pages/starterDashboardV2/shared/types';

export function useDashboardShareChannels(): OnlineShareChannel[] {
	const { globalShareButtonConfig } = useStarterDashboardV2PageFcm();
	const {
		data: {
			petition: { geoReach },
		},
	} = useStarterDashboardV2PageData();

	const excludemobileNativeShareConfig = globalShareButtonConfig.filter((ch) => ch !== 'mobileNativeShare');

	// Most of our social share components use the same global_share_button_config FC. Hence the filtering.
	if (excludemobileNativeShareConfig.includes('nextdoor') && geoReach !== 'local') {
		return excludemobileNativeShareConfig.filter((ch) => ch !== 'nextdoor');
	}

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return excludemobileNativeShareConfig as OnlineShareChannel[];
}
